import _get from 'lodash/get'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'
//
export const methods = {
  async setPhotoAsPrimary(photo) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    const { documentID, unitPhotoID, unitID } = photo
    var params = {}
    try {
      params.documentID = parseInt(documentID)
      params.unitPhotoID = parseInt(unitPhotoID)
      params.unitID = parseInt(unitID)
      params.isPrimary = true

      if (
        params.unitPhotoID === undefined ||
        params.unitID === undefined ||
        !params.unitPhotoID ||
        !params.unitID
      ) {
        notifyProblem('Sorry, a problem occurred and the photo could not be set as primary.')
        console.debug({ params })
        return
      }
    } catch (exception) {
      loadingComponent.close()
      notifyProblem('Sorry, a problem occurred and the photo could not be set as primary.')
      console.debug(exception)
    }

    try {
      const result = await kms.get(`/Roster/UnitPhoto/${params.unitPhotoID}`)

      if (result && result.documentID) {
        params.documentID = result.documentID
      }

      if (params.documentID !== undefined && params.documentID && params.documentID > 0) {
        await kms.put(`/Roster/UnitPhoto`, params)
        this.updateOccurred()
      } else {
        notifyProblem('Sorry, a problem occurred and the photo could not be set as primary.')
      }
    } catch (exception) {
      loadingComponent.close()
      console.error(exception)
      return
    }

    loadingComponent.close()
  },
  confirmDeletePhoto(photo) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Photo',
      message: `Are you sure you want to <b>delete</b> this photo? <img src="${photo.src}" style="max-width: 102px; max-height: 102px; margin: 20px auto; border-radius: 4px;" />`,
      confirmText: 'Delete Photo',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => this.deletePhoto(photo)
    })
  },
  async deletePhoto(photo) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    try {
      console.debug('unitPhotoID=' + JSON.stringify(photo))
      const unitPhotoID = parseInt(photo.unitPhotoID)

      if (unitPhotoID < 1) {
        notifyProblem('A problem occurred and the photo could not be set as primary.')
        console.debug({ unitPhotoID })
        return
      }

      await kms.delete(`/Roster/UnitPhoto/${unitPhotoID}?forceDelete=true`)

      this.updateOccurred()
    } catch (exception) {
      loadingComponent.close()
      notifyProblem('A problem occurred and the photo could not be deleted.')
    }

    loadingComponent.close()
  },
  getTheme() {
    const theme = _get(this, ['$store', 'getters', 'state', 'theme'], {})

    return {
      star: {
        contour: _get(theme, ['color', '3'], '#000'),
        primary: {
          color: _get(theme, ['color', '1'], 'purple')
        },
        nonPrimary: {
          color: 'none'
        }
      },
      closeColor: _get(theme, ['color', '2'], '#fff')
    }
  },

  showEditGallery() {
    console.debug('showEditGallery...')
    this.editModeData = !this.editModeData

    if (this.editModeData) {
      this.iconPadding = '10px'
    } else {
      this.iconPadding = '0px'
    }
  }
}
